import { createQueryKey } from '../query/createQueryKeyFactory';
import { featureFlagsKeys } from './flags/keys';

const featureKeys = createQueryKey({
  all: ['feature'] as const,
  flags: featureFlagsKeys(['feature']),
});

export { featureKeys };
